"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GreatProfit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var GreatProfit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GreatProfit, _super);
    function GreatProfit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '众禄基金萬份收益走勢';
        _this.code = '106022';
        _this.desc = '众禄基金萬份收益走勢';
        _this.requestParams = new zl_1.GreatProfitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GreatProfit;
}(service_1.BaseService));
exports.GreatProfit = GreatProfit;
//# sourceMappingURL=greatProfit.js.map